import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Modal } from 'bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { errorCss } from '../Utils/formik-util';
import { Dropdown } from 'primereact/dropdown';
import { comparer } from '../../utils/comparer'
import { useToast } from '../../toastHook'
import { ConfirmModalComponent } from '../Utils/ConfirmModal'

export const CompetenceLieeComponent = () => {
    const { display } = useToast();
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false);

    const [rows, setRows] = useState([]);
    const [competences, setCompetences] = useState([]);
    const [nbModifs, setNbModifs] = useState(0);

    const modalRefInsert = useRef();
    const modalRefUpdate = useRef();
    const [competenceToInsert, setCompetenceToInsert] = useState('');

    const [toRemoveCompetence, setToRemoveCompetence] = useState('');
    const [toRemoveCompetenceLiee, setToRemoveCompetenceLiee] = useState('');

    const [competenceToUpdate, setCompetenceToUpdate] = useState('');
    const [competenceLieeToUpdate, setCompetenceLieeToUpdate] = useState('');

    const insertFormValidationSchema = Yup.object().shape({
        competenceLiee: Yup.string()
            .required('Requis')
            .oneOf(competences.map(x => x.value), 'compétence incorrecte'),
        ponderation: Yup.number().min(0, 'doit être supérieur à 0').max(1, 'doit être inférieur à 1').required('Requis')
    });

    const updateFormValidationSchema = Yup.object().shape({
        ponderation: Yup.number().min(0, 'doit être supérieur à 0').max(1, 'doit être inférieur à 1').required('Requis')
    })

    const insertFormik = useFormik({
        initialValues: {
            competenceLiee: '',
            ponderation: ''
        },
        validationSchema: insertFormValidationSchema,
        onSubmit: values => {

            const competence = competenceToInsert;
            axios.post('/api/competenceliee/add', {
                competence: competence,
                ponderation: values.ponderation,
                competenceLiee: values.competenceLiee
            }).then(response => {
                if (response.status === 200) {

                    display({
                        titre: 'compétence liée ajouté',
                        text: `la compétence liée '${values.competence}' a été ajouté à la compétence ' ${competence}`,
                        severity: 'success'
                    });

                    setNbModifs(nbModifs + 1);
                }
                else {
                    display({
                        titre: 'compétence liée non ajouté',
                        text: `la compétence liée '${values.competence}' n'a pas pu être ajouté à la compétence liée' ${competence}`,
                        severity: 'danger'
                    })
                }
            });


            const modal = Modal.getOrCreateInstance(modalRefInsert.current);
            modal.hide();
        }
    });

    const updateFormik = useFormik({
        initialValues: {
            ponderation: ''
        },
        validationSchema: updateFormValidationSchema,
        onSubmit: values => {

            axios.post('/api/competenceliee/update', {
                competenceLiee: competenceLieeToUpdate,
                ponderation: values.ponderation,
                competence: competenceToUpdate
            }).then(response => {
                if (response.status == 200) {

                    display({
                        titre: 'compétence liée modifiée',
                        text: `la compétence liée '${competenceLieeToUpdate}' de la compétence ' ${competenceToUpdate} a maintenant une pondération ${values.priorite}`,
                        severity: 'success'
                    });

                    setNbModifs(nbModifs + 1);
                }
                else {
                    display({
                        titre: 'compétence liée non modifiée',
                        text: `la propriété de la compétence liée '${competenceLieeToUpdate}' de la compétence ' ${competenceToUpdate} n'a pas pu être modifiée'`,
                        severity: 'danger'
                    })
                }
            });

            const modal = Modal.getOrCreateInstance(modalRefUpdate.current);
            modal.hide();
        }
    });

    useEffect(() => {
        axios.get('/api/competenceliee/get')
            .then(response => {
                if (response.data) {

                    let tmpRows = [];

                    for (const key in response.data) {
                        const values = response.data[key];

                        const tmpValues = values.map(x => {
                            return {
                                key: key + '-' + x.competence,
                                data: {
                                    competence: key,
                                    competenceLiee: x.competence,
                                    ponderation: x.ponderation
                                }
                            }
                        })

                        tmpRows.push({
                            key: key,
                            data: {
                                competence: key,
                                competenceLiee: '',
                                ponderation: '',
                            },
                            children: tmpValues
                        });
                    }

                    setRows(tmpRows);
                }
            });
    }, [nbModifs]);

    useEffect(() => {
        axios.get('/api/competences/get').then(response => {
            let tmpCompetences = response.data.map(x => { return { value: x } }
            );
            tmpCompetences.sort((x, y) => comparer(x.value, y.value));
            setCompetences(tmpCompetences)
        })
    }, []);

    const templateButton = x => {
        if (x.data.competenceLiee) {
            return <div><i className="pi pi-sync text-success me-3" onClick={() => {
                setCompetenceToUpdate(x.data.competence);
                setCompetenceLieeToUpdate(x.data.competenceLiee)

                updateFormik.setFieldValue('ponderation', x.data.ponderation)

                const modal = Modal.getOrCreateInstance(modalRefUpdate.current);
                modal.show();
            }}

            ></i>
                <i className="pi pi-times-circle text-danger" onClick={() => {
                    setToRemoveCompetence(x.data.competence);
                    setToRemoveCompetenceLiee(x.data.competenceLiee);

                    setOpenConfirmRemoveModal(true);
                }} ></i></div>
        }
        else {
            return <div><i className="pi pi-plus text-success" onClick={() => {
                setCompetenceToInsert(x.data.competence);
                insertFormik.resetForm();

                const modal = Modal.getOrCreateInstance(modalRefInsert.current);
                modal.show();

            }}></i></div>
        }
    }

    const removeCompetenceLiee = () => {
        axios.get('/api/competenceLiee/remove?competenceLiee=' + encodeURIComponent(toRemoveCompetenceLiee) + '&competence=' + encodeURIComponent( toRemoveCompetence) ).then(response => {
            if (response.status === 200) {

                display({
                    titre: 'compétence liée retiré',
                    text: `la compétence liée '${toRemoveCompetenceLiee}' a été retiré à la compétence ' ${toRemoveCompetence}`,
                    severity: 'success'
                });

                setNbModifs(nbModifs + 1);
            }
            else {
                display({
                    titre: 'compétence liée non retiré',
                    text: `la compétence liée '${toRemoveCompetenceLiee}' n'a pas pu être retiré à la compétence ' ${toRemoveCompetence}`,
                    severity: 'danger'
                })
            }
        });
    }

    return <div>
        <div className="alert alert-info">
            Voici le liste des compétence liée de la plateforme. <br />
            Une compétence liée sera calculée si la compétence associée est demandée par l'appel d'offre avec la pondération.
            <br />
            Par exemple: Si Javascript est une compétence Liée de React. Un cv aura une pondération s'il a la compétence Javascript et que l'appel d'offre demande du React
        </div>
        <div ref={modalRefInsert} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter une compétence liée</h5>
                    </div>
                    <form onSubmit={insertFormik.handleSubmit}
                    >
                        <div className="modal-body"  >
                            <div className="alert alert-info">Vous allez ajouter une compétence liée à la compétence <b>{competenceToInsert}</b></div>
                            <div className="form-group">
                                <label htmlFor="competenceLiee">Compétence Liée</label>
                                {/*<Dropdown onChange={insertFormik.handleChange}*/}
                                {/*    name="competenceLiee" value={insertFormik.values.competenceLiee} options={competences} optionLabel="value" optionValue="value" placeholder="Sélectionner une compétence"*/}
                                {/*    filter className={`form-control ${errorCss(insertFormik.errors.competenceLiee)}`} />*/}
                                <input list="competences-list" className={`form-select ${errorCss(insertFormik.errors.competenceLiee)}`} onChange={insertFormik.handleChange} value={insertFormik.values.competenceLiee} name="competenceLiee" />
                                <datalist id="competences-list">
                                    {competences.map(x => <option key={x.value} value={x.value} />)}
                                </datalist>
                                {insertFormik.errors.competenceLiee ? (
                                    <div className="invalid-feedback">{insertFormik.errors.competenceLiee}</div>
                                ) : (<></>)}
                            </div>
                            <div className="form-group">
                                <label htmlFor="ponderation">Pondération</label>
                                <input name="ponderation" onChange={insertFormik.handleChange}
                                    value={insertFormik.values.ponderation} type="number" step="0.01" id="ponderation" className={`form-control ${errorCss(insertFormik.errors.ponderation )}`}></input>
                                {insertFormik.errors.ponderation ? (
                                    <div className="invalid-feedback">{insertFormik.errors.ponderation}</div>
                                ) : (<></>)}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success"  >Valider</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div ref={modalRefUpdate} className="modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifier la pondération d'une compétence liée</h5>
                    </div>
                    <form onSubmit={updateFormik.handleSubmit}
                    >
                        <div className="modal-body"  >
                            <div className="alert alert-info">Vous allez modifier la pondération pour la compétence liée <b>{competenceLieeToUpdate}</b> de la compétence <b>{competenceToUpdate}</b></div>

                            <div className="form-group">
                                <label htmlFor="ponderation">Priorité</label>
                                <input name="ponderation" onChange={updateFormik.handleChange}
                                    value={updateFormik.values.ponderation} type="number" id="ponderation" className={`form-control ${errorCss(updateFormik.errors.ponderation )}`}></input>
                                {updateFormik.errors.ponderation ? (
                                    <div className="invalid-feedback">{updateFormik.errors.ponderation}</div>
                                ) : (<></>)}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success"  >Valider</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <TreeTable value={rows} sortMode="multiple" >

            <Column field="competence" sortable header="Compétence" filter expander></Column>

            <Column field="competenceLiee" sortable header="Compétence Liée" filter></Column>

            <Column field="ponderation" sortable header="pondération" ></Column>
            <Column body={templateButton} />

        </TreeTable>
        <ConfirmModalComponent open={openConfirmRemoveModal} setOpen={setOpenConfirmRemoveModal} titre="êtes vous sure de supprimer ?" message={`Vous allez supprimer la competence '${toRemoveCompetenceLiee}' pour la compétence liée '${toRemoveCompetence}' , êtes-vous sure ? `} onConfirm={removeCompetenceLiee} />
    </div>
}